import React, { useState } from "react";
import TooltipHLPure from "../tooltipHL/tooltipHL.pure";
import "./checkBoxHL.css";

const CheckBoxHLPure = (props) => {
  const {
    labelCheckBox, //Label to check
    valueCheckBox, //Value to check
    idCheckBox, //Id checkBox, string, number, you can use value labelCheckBox
    onChangeHandler, //Funtion to check
    checkedState, //State that change check
    tooltipShow, //True or false to show tooltip
    positionTooltip, //Position tooltip (top, left, right, bottom) string
    titleTooltip, //Title tooltip string
    descriptionTooltip, //Description tooltip string
    subContent, //More text to tooltip description optional
    restContent, //More text to tooltip description optional
    informationIcon, // Choose the information icon true or false to custom img
    disabled, // Boolean to disable checkbox
    required = false // Boolean to show asterisk if required
  } = props;

  const [valueCheck, setValueCheck] = useState(valueCheckBox || false);
  const handleChange = (event) => {
    setValueCheck(event.target.checked);
  };

  return (
    <div className='checkBoxHLPure-container'>
      <div className='checkBoxHLPure-checkbox-wrapper'>
        <input
          type="checkbox"
          className="checkBoxHLPure-input"
          {...props}
          id={idCheckBox}
          name={labelCheckBox}
          value={valueCheck}
          checked={checkedState}
          onChange={onChangeHandler ? onChangeHandler : handleChange}
          disabled={disabled}
        />
        <label
          className='checkBoxHLPure-label'
          htmlFor={idCheckBox}
        >
          <div className='checkBoxHLPure-label-text'>{labelCheckBox}</div>{required && " *"}
        </label>
        {tooltipShow && (
          <div
            className='checkBoxHLPure-tooltip-wrapper'
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
          >
            <TooltipHLPure
              positionTooltip={positionTooltip}
              titleTooltip={titleTooltip}
              descriptionTooltip={descriptionTooltip}
              subContent={subContent}
              restContent={restContent}
              informationIcon={informationIcon}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export { CheckBoxHLPure as default };
